(() => {
  const selector = '.nuances-product-accordion';

  const bindAccordions = (root = document) => {
    root.querySelectorAll(selector).forEach((accordion) => {
      if (accordion.dataset.nuancesAccordionBound === 'true') return;
      accordion.dataset.nuancesAccordionBound = 'true';

      accordion.addEventListener('toggle', () => {
        if (!accordion.open) return;

        const container =
          accordion.closest('.product__description') ||
          accordion.parentElement;

        container.querySelectorAll(selector).forEach((other) => {
          if (other !== accordion && other.open) other.open = false;
        });
      });
    });
  };

  document.addEventListener('DOMContentLoaded', () => bindAccordions());
  document.addEventListener('shopify:section:load', (event) => bindAccordions(event.target));
})();
